export default "__VITE_ASSET__CidiXUGd__"